<template>
  <div>
    <div>我的文章</div>


    <div class="mt30">
      <el-input style="width: 336px" v-model="search.information_title" placeholder="请输入文章标题"></el-input>
      <el-button class="ml20" type="primary" @click="getMemberInformationList">搜索</el-button>
      <el-button style="width: 120px" type="primary" @click="go('/myInformation/add')">发表文章</el-button>

    </div>

    <!--    分割线-->
    <el-divider></el-divider>

    <!--    文章列表-->

    <div class="article-list">
      <div class="item p10 cursor" v-for="(item,index) in information_list" style="border-bottom: 1px solid #f5f5f5" @click="go(`/myInformation/detail?information_id=${item.information_id}`)">

        <div class="fr jsb ac">
          <div>{{item.information_title}}</div>
          <div>{{item.create_time}}</div>
        </div>

        <div class="fz14 grey mt10">{{item.information_desc}}</div>
      </div>

    </div>


    <!--    分页-->

    <div class="fr jc ac p50">

      <el-pagination background
                     :current-page.sync="pagination.page"
                     @current-change="getMemberInformationList"
                     layout="prev, pager, next"
                     :total="pagination.total">
      </el-pagination>
    </div>
  </div>
</template>

<script>


  export default {
    data() {
      return {
        search: {
          information_title: ""
        },
        pagination: {
          page: 1,
          pageSize: 10,
          total: 0
        },
        information_list: []


      }
    }, mounted() {
      this.getMemberInformationList();
    }
    , methods: {

      // 获取文章列表
      getMemberInformationList() {
        let param={
          page: this.pagination.page,
          information_title:this.search.information_title
        };
        this.post("informationInterfaces/v1.0/getMemberInformations", param).then(res => {
          this.information_list = res.data;
          this.pagination.total = res.total;
        });

      }
    }
    , components: {}
  }
</script>

<style scoped lang="scss">

</style>


// WEBPACK FOOTER //
// src/page/me/myInformation/index.vue